﻿import {
    ValgStateActionTypes,
    ValgState,
    UPDATE_VALG,
} from './Types';

import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { VeilederBetalingskalkulatorAppState } from '..';
import { AnyAction } from 'redux';
import { setVisning } from '../Resultat/Actions';

export function updateValg(newValg: Partial<ValgState>): ValgStateActionTypes {
    return {
        type: UPDATE_VALG,
        payload: newValg,
    };
}

export const updateVisning = (): ThunkAction<void, VeilederBetalingskalkulatorAppState, {}, AnyAction> => {
    return (dispatch: ThunkDispatch<VeilederBetalingskalkulatorAppState, {}, AnyAction>, getState: () => VeilederBetalingskalkulatorAppState): void => {
        const currentState = getState();
        const visBoksB = visB(currentState);
        
        dispatch(
            setVisning({
                visBoksB,
            }),
        );
    };
};

const visB = (state: VeilederBetalingskalkulatorAppState): boolean => {
    return false;
};

